function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { v4 as uuidv4 } from 'uuid';
import { runEngine } from '../../../framework/src/RunEngine';
import { Message } from '../../../framework/src/Message';
import MessageEnum, { getName } from '../../../framework/src/Messages/MessageEnum';
export default class AlertPageWebAdapter {
  constructor() {
    _defineProperty(this, "convert", from => {
      const to = new Message(getName(MessageEnum.NavigationMessage));
      to.addData(getName(MessageEnum.NavigationTargetMessage), 'AlertWeb');
      to.addData(getName(MessageEnum.NavigationPropsMessage), from.getData(getName(MessageEnum.NavigationPropsMessage)));
      const raiseMessage = new Message(getName(MessageEnum.NavigationPayLoadMessage));
      raiseMessage.copyAllPropertiesOf(from);

      // let alertType = message.getData(getName(MessageEnum.AlertTypeMessage));
      // let title = message.getData(getName(MessageEnum.AlertTitleMessage));
      // let body = message.getData(getName(MessageEnum.AlertBodyMessage));

      // let btnPositiveText = message.getData(getName(MessageEnum.AlertButtonPositiveText));
      // let btnPositiveMessage = message.getData(getName(MessageEnum.AlertButtonPositiveMessage));

      // let btnNegativeText = message.getData(getName(MessageEnum.AlertButtonNegativeText));
      // let btnNegativeMessage = message.getData(getName(MessageEnum.AlertButtonNegativeMessage));

      // let btnNeutralText = message.getData(getName(MessageEnum.AlertButtonNeutralText));
      // let btnNeutralMessage = message.getData(getName(MessageEnum.AlertButtonNeutralMessage));

      to.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
      return to;
    });
    const blockId = uuidv4();
    this.send = message => runEngine.sendMessage(blockId, message);
    console.log('initing AlertPageWebAdapter');
    runEngine.attachBuildingBlock(this, [getName(MessageEnum.NavigationAlertWebMessage)]);
  }
  receive(from, message) {
    console.log("receive AlertPageWebAdapter==>".concat(JSON.stringify(message)));
    console.log("Converted AlertPageWebAdapter==>".concat(JSON.stringify(this.convert(message))));
    this.send(this.convert(message));
  }
}